import { z } from "zod";
const phoneCleanRegex = /^\+?\d{6,15}$/;
export const phoneSchema = z
    .string()
    .transform((value) => value.replace(/[\s().-]/g, ""))
    .refine((value) => value === "" || phoneCleanRegex.test(value), {
    message: "Numero invalide (ex: +33 6 12 34 56 78 ou 0612345678)",
})
    .optional();
